module.exports = __webpack_public_path__ + "img/cl-flag.edf2e403.png";